<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="rotationChart">
      <el-image :src="lb1" style="width:100%;height:390px; margin-bottom: 8px;" fit="fill"></el-image>
    </div>

    <!-- 滚动通知栏 -->
    <div v-if="sliderData.length > 0" class="notice-bar"
      style="width: 100%;margin: 0 auto;text-align: center;background-color: #F1F3F5">
      <horizontal-text-slider :slider-data="sliderData" :totalWidth="2200" :amount="1" :height="40"
        style="background-color: #fff; width: 100%;"></horizontal-text-slider>
    </div>

    <div v-if="sliderData1.length > 0" class="notice-bar"
      style="width: 100%;margin: 0 auto;text-align: center;background-color: #F1F3F5">
      <horizontal-text-slider :slider-data="sliderData1" :totalWidth="2200" :amount="1" :height="40"
        style="background-color: #fff; width: 100%;" @click="onClick"></horizontal-text-slider>
    </div>

    <!-- 主要内容区域 -->
    <div class="content">
      <div class="content_top">
        <div class="content_top_content">
          <div class="content_top_content_left">
            <!-- 标签页导航 -->
            <div class="tab-button-group">
              <div v-for="(item, index) in contentList1" :key="item.value" class="tab-button"
                :class="{ active: content1Name === item.value }" @click="switchTab(item.value)">
                {{ item.label }}
              </div>
            </div>

            <!-- 公告内容区域 -->
            <div class="tab-content-container">
              <!-- 通知公告 -->
              <div v-if="content1Name === 'tzgg'" class="white-bg">
                <div :underline="false" v-for="(item, index) in tzggList" :key="item.id" style="height: 46px;">
                  <div :class="{ 'toolitem': true, 'action': toolaction === index }" @click="goNewsDetail(item.id)"
                    @mouseenter="toolaction = index" @mouseleave="toolaction = -1">
                    <div style="display: flex;justify-content: space-between;align-items: center;font-size: 14px">
                      <div style="width: 230px;margin-left: 10px;">
                        <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                          <el-button type="text" style="color: #000;">
                            {{ item.name.length > 37 ? item.name.slice(0, 37) + '...' : item.name }}
                          </el-button>
                        </el-tooltip>
                      </div>
                      <div style="width: 90px;margin-left: 10px;">{{ formatDate(item.createTime) }}</div>
                    </div>
                  </div>
                </div>

                <!-- 查看更多按钮 -->
                <div v-if="tzggList.length >= 10" style="text-align: center; margin-top: 10px;">
                  <el-button type="text" @click="contentMore">查看更多 ></el-button>
                </div>
              </div>

              <!-- 招标公告 / 招募公告 -->
              <div v-if="content1Name === 'zbgg' || content1Name === 'zmgg'" class="white-bg">
                <div :underline="false" v-for="(item, index) in (content1Name === 'zbgg' ? zbggList : zmggList)"
                  :key="item.id" style="height: 46px;">
                  <div :class="{ 'toolitem': true, 'action': toolaction === index }" @click="goToPage(item.id)"
                    @mouseenter="toolaction = index" @mouseleave="toolaction = -1">
                    <div style="display: flex;justify-content: space-between;align-items: center;font-size: 14px">
                      <div style="width: 230px;margin-left: 10px;">
                        <el-tooltip class="item" effect="dark" :content="item.ggName" placement="bottom">
                          <el-button type="text" style="color: #000;">
                            {{ item.ggName.length > 37 ? item.ggName.slice(0, 37) + '...' : item.ggName }}
                          </el-button>
                        </el-tooltip>
                      </div>
                      <div style="width: 90px;margin-left: 10px;">{{ formatDate(item.ggStartTime) }}</div>
                    </div>
                  </div>
                </div>

                <div v-if="(content1Name === 'zbgg' && zbggList.length >= 10) || (content1Name === 'zmgg')"
                  style="text-align: center; margin-top: 10px;">
                  <el-button type="text" @click="contentMore">查看更多 ></el-button>
                </div>
              </div>
            </div>
          </div>

          <div class="content_top_content_right">
            <!-- 上方大图 -->
            <div class="top-image">
              <el-image :src="homeImage" style="width: 100%; height: 80px; padding: 0;" fit="fill"></el-image>
            </div>

            <!-- 中间三排两列图片 + 文本 -->
            <div class="grid-images">
              <div v-for="(item, index) in gridImages" :key="item.id" class="grid-item" @click="content2More(item)">
                <div class="image-wrapper">
                  <el-image :src="item.url" style="width: 100%; height: 80px;" fit="cover"></el-image>
                </div>
                <div class="text-below">
                  {{ item.text || '默认文案' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 业务模块 -->
      <div class="content_BusinessModule">
        <div style="margin: 0 auto;max-width: 1360px;padding: 0 20px">
          <h2 style="color:#333333; margin-top: 20px;text-align: center;">业务模块</h2>
          <div
            style="width: 100%;height: 20px;font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;margin-top: 11px;
font-weight: normal;font-size: 20px;color: #999999;line-height: 20px;text-align: center;font-style: normal;text-transform: none;">
            全场景解决您的使用需求，构建产业生态链
          </div>
          <div class="business-grid">
            <div class="content_BusinessModule_content" style="border-radius: 15px 15px 15px 15px"
              v-for="(item, index) in businessList" :key="item.id" @click="businessMore(item)">
              <el-image :src="item.url" class="business-image"
                style="width:100%;height:inherit;border-radius: 15px 15px 0 0" fit="fill"></el-image>
              <div style="display: flex;justify-content: space-between">
                <div>
                  <div
                    style="display: flex; justify-content: left; align-items: center; gap: 10px;margin: 16px 0 0 24px;">
                    <div
                      style="font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30; font-weight: normal; font-size: 24px; color: #13319F; line-height: 18px; text-align: center; font-style: normal; text-transform: none;">
                      {{ item.label }}
                    </div>
                    <div
                      style="font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30; font-weight: normal; font-size: 16px; color: #13319F; line-height: 14px; text-align: center; font-style: normal; text-transform: none; padding-top: 1px;">
                      {{ item.val }}
                    </div>
                  </div>
                  <br />
                  <span style="font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
        font-weight: normal;
        font-size: 14px;
        color: #999999;
        line-height: 1px;
        margin-left: 24px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        position: relative;
        top: -5px;" v-html="item.value"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div class="login-mask" v-if="logoDialog" @click="closeLoginDialog"></div>

    <!-- 登录弹窗 -->
    <div class="login-dialog" v-if="logoDialog" @keydown.esc="closeLoginDialog">
      <div class="dialog-header">
        <span class="title">请选择登录方式</span>
        <div class="close-icon" @click="closeLoginDialog">
          <img src="@/assets/guanbi.png" alt="关闭" />
        </div>
      </div>
      <div class="login-options">
        <div class="login-option" @click="selectLogo(2)">
          <span>供应商登录</span>
        </div>
        <div class="login-option" @click="selectLogo(3)">
          <span>采购人登录</span>
        </div>
        <div class="login-option" @click="selectLogo(5)">
          <span>平台方登录</span>
        </div>
      </div>
    </div>

    <!-- 飘动的声明飘窗 -->
    <div v-if="showFloatNotice" @mouseover="floatMouseOver" @mouseout="floatMouseOut" class="float-notice"
      :style="{ 'top': floatTop + 'px', 'left': floatLeft + 'px' }">
      <div class="float-header">
        <span>重要声明</span>
        <button class="close-btn" @click="closeFloatNotice">×</button>
      </div>
      <div class="float-body">
        采购流程全部完成后必须对所有资料进行“一键归档”，将归档的资料保存到本地存储设备，并按各自所属公司的要求进行保存。由于未及时归档造成的后果，平台不负责任。
      </div>
    </div>
  </div>
</template>

<script>
// 导入图片资源
import lb from '@@/assets/images/lunbo1.jpg'
import xcyc from '@@/assets/images/xcyc.jpg'
import xcwl from '@@/assets/images/xcwl.jpg'
import xcyp from '@@/assets/images/xcyp.jpg'
import zqyl from '@@/assets/images/zqyl.png'
import fjwz from '@@/assets/images/fjwz.png'
import xcys from '@@/assets/images/xcys.jpg'
import lb1 from '@@/assets/images/lunbo1(1).png'

// 导入api接口
import {
  noticeApi,
  lbimages,
  getLoginStatus,
  getGgListHome,
  getZmggListTwoMonth,
} from "@@/api/api";
import Cookies from "js-cookie";
import HorizontalTextSlider from "@/views/HorizontalTextSlider.vue";

export default {
  components: { HorizontalTextSlider },
  data() {
    return {
      // 图片资源
      lb,
      xcyc,
      xcwl,
      xcyp,
      zqyl,
      fjwz,
      xcys,
      lb1,

      // 飘窗相关数据
      showFloatNotice: true,
      floatTop: 100,
      floatLeft: 100,
      stepX: 1,
      stepY: 1,
      floatTimer: null,
      maxFloatTop: 0,
      maxFloatLeft: 0,

      homeImage: require('@/assets/images/homeImage/home1.png'),
      gridImages: [

        { url: require('@/assets/images/homeImage/home2.png'), text: '旭诚云采', label: "旭诚云采", id: "1" },
        { url: require('@/assets/images/homeImage/home3.png'), text: '旭诚云市', label: "旭诚云市", id: "5" },
        { url: require('@/assets/images/homeImage/home5.png'), text: '评标系统', label: "旭诚云采", id: "7" },
        { url: require('@/assets/images/homeImage/home7.png'), text: '合同签署', label: "合同签署", id: "10" },
        { url: require('@/assets/images/homeImage/home19.png'), text: '文件签署', label: "文件签署", id: "6" },
        { url: require('@/assets/images/homeImage/home15.jpg'), text: '招标控制价计算工具', label: "旭诚云采", id: "2" },
        // { url: require('@/assets/images/homeImage/home14.jpg'), text: '合同签署', label: "合同签署", id: "9" },
      ],

      // 通知数据
      sliderData: [
        {
          title: '开标时，招标员需要对各投标单位开标当日的资信等信用状况进行查询。',
        },
        {
          title: '开标时，招标员需要对各投标单位开标当日的资信等信用状况进行查询。',
        },
      ],
      sliderData1: [
        {
          title: '评标时，在评标报告签名之前，请所有评委务必点击“评标签名”进行评标过程文件签字。如有操作问题，请拨打电话0311-68007076进行咨询。',
          id: '1968514173477384193'
        },
        {
          title: '评标时，在评标报告签名之前，请所有评委务必点击“评标签名”进行评标过程文件签字。如有操作问题，请拨打电话0311-68007076进行咨询。',
          id: '1968514173477384193'
        },
      ],

      /** 内容区域 */
      content1Name: 'zbgg',
      tzggList: [],
      zbggList: [],
      zmggList: [],
      content2Name: '',
      contentList1: [
        { label: "招标公告", id: "2", value: 'zbgg' },
        { label: "通知公告", id: "1", value: 'tzgg' },
        { label: "招募公告", id: "1", value: 'zmgg' },
      ],
      contentList2: [
        { label: "快捷入口", id: "1", value: '' },
      ],
      contentRight: [
        { label: "旭诚云采", id: "1", value: '' },
        { label: "旭诚云市", id: "5", value: '' },
        { label: "评标系统", id: "7", value: '' },
        { label: "合同签署", id: "9", value: '' },
        { label: "招标控制价计算工具", id: "2", value: '' },
        // { label: "供应链金融-联易融", id: "4", value: '' },
        { label: "帮助中心", id: "3", value: '' },
      ],

      /** 业务模块 */
      businessList: [
        { label: "旭诚云采", id: "1", value: '集中采购&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公平公正&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合法合规', val: '招投标、电子采购平台', url: require('@/assets/images/homeImage/home8.png') },
        { label: "旭诚云市", id: "4", value: '日常用品&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;质量保证&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价格优惠', val: '企业采购商城', url: require('@/assets/images/homeImage/home10.png') },
        { label: "评标系统", id: "3", value: '全程留痕&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客观公正&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;高效严谨', val: '线上智能评标系统', url: require('@/assets/images/homeImage/home18.jpg') },
        { label: "合同签署", id: "5", value: '电子签章&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;文件存证&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;线上签约', val: '规范合同全生命周期管理', url: require('@/assets/images/homeImage/home17.jpg') },
        {
          label: "文件签署",
          id: "6",
          value: '电子签章&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;快速签发&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安全存证',
          val: '各类业务文件线上签发签署',
          url: require('@/assets/images/homeImage/home20.png')
        },
        { label: "招标控制价计算工具", id: "2", value: '数据核算&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;清单计价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;造价辅助', val: '高效编制控制价格', url: require('@/assets/images/homeImage/home16.jpg') },
        // { label: "废旧物资交易平台", id: "6", value: '敬请期待', val: '敬请期待......', url: require('@/assets/images/homeImage/home13.png') }
      ],

      /** 底部链接 */
      bottomList1: [
        { label: '住建集团', url: '' },
        { label: '石建工集团', url: '' },
      ],
      bottomList2: [
        { label: '中国招投标公共服务平台', url: 'http://www.cebpubservice.com/' },
        { label: '河北省招投标公共服务平台', url: 'http://www.hebeieb.com/' },
        { label: '河北省投资项目在线市批监管平台', url: 'http://tzxm.hbzwfw.gov.cn/sbglweb/index' },
        { label: '河北省政府采购网', url: 'http://www.ccgp-hebei.gov.cn/province/' },
      ],

      toolaction: -1,
      imagelist: [{ pictureUrl: 'http://www.xcsw.net:1080/m/test/static/image/海报.jpg' }],
      logoDialog: false
    };
  },
  created() {
    this.getUrl();
  },
  mounted() {
    // 初始化飘窗
    this.initFloatWindow();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleWindowResize);
  },
  watch: {
    logoDialog(newVal) {
      if (newVal) {
        // 打开弹窗时禁止滚动
        document.body.style.overflow = 'hidden';
        // 打开弹窗时绑定事件
        window.addEventListener('keydown', this.handleKeydown);
      } else {
        // 关闭弹窗时恢复滚动
        document.body.style.overflow = 'auto';
        // 关闭弹窗时解绑事件
        window.removeEventListener('keydown', this.handleKeydown);
      }
    },
  },
  beforeDestroy() {
    // 组件销毁前移除监听
    window.removeEventListener('keydown', this.handleKeydown);
    // 清除飘窗定时器
    if (this.floatTimer) {
      clearInterval(this.floatTimer);
    }
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    /** 飘窗相关方法 */
    initFloatWindow() {
      // 计算最大可移动范围（窗口大小 - 飘窗大小）
      this.maxFloatTop = window.innerHeight - 200; // 200是飘窗高度
      this.maxFloatLeft = window.innerWidth - 350;  // 350是飘窗宽度

      // 设置初始位置在左上角
      this.floatTop = 0;
      this.floatLeft = 0;

      // 启动移动
      this.startFloatMove();
    },

    startFloatMove() {
      // 先清除已有定时器
      if (this.floatTimer) {
        clearInterval(this.floatTimer);
      }

      this.floatTimer = setInterval(() => {
        // 更新位置
        this.floatTop += this.stepY;
        this.floatLeft += this.stepX;

        // 边界检测，碰到边界则反向并修正位置
        if (this.floatTop <= 0) {
          this.floatTop = 0;
          this.stepY = Math.abs(this.stepY);
        } else if (this.floatTop >= this.maxFloatTop) {
          this.floatTop = this.maxFloatTop;
          this.stepY = -Math.abs(this.stepY);
        }

        if (this.floatLeft <= 0) {
          this.floatLeft = 0;
          this.stepX = Math.abs(this.stepX);
        } else if (this.floatLeft >= this.maxFloatLeft) {
          this.floatLeft = this.maxFloatLeft;
          this.stepX = -Math.abs(this.stepX);
        }
      }, 30); // 移动速度控制
    },

    floatMouseOver() {
      if (this.floatTimer) {
        clearInterval(this.floatTimer);
      }
    },

    floatMouseOut() {
      this.startFloatMove();
    },

    closeFloatNotice() {
      if (this.floatTimer) {
        clearInterval(this.floatTimer);
      }
      this.showFloatNotice = false;
    },

    handleWindowResize() {
      this.maxFloatTop = window.innerHeight - 200;
      this.maxFloatLeft = window.innerWidth - 350;
    },

    /** 标签页切换 */
    switchTab(val) {
      this.content1Name = val;
      this.contentLeft({ name: val });
    },

    /** 登录弹窗控制 */
    closeLoginDialog() {
      this.logoDialog = false;
      document.body.style.overflow = 'auto';
    },

    handleKeydown(e) {
      if (e.key === 'Escape') {
        this.closeLoginDialog();
      }
    },

    /** 初始化页面数据 */
    async getUrl() {
      const str = window.location.href;
      if (str.indexOf("dzzb.sjzszjjt.com") !== -1) {
        try {
          await this.$alert(
            '重要通知:旭诚商务平台于2025年1月1日更换新网址(www.xcsw.net),请前往新网址进行登录',
            '',
            {
              confirmButtonText: '跳转',
              showClose: false
            }
          );
          window.location.replace('https://www.xcsw.net/home');
        } catch (error) {
          // 用户关闭了弹窗，不做任何操作
          console.log('用户取消了跳转');
        }
      } else {
        this.notice();
        this.lbimages();
        this.getGgList('zbgg');
      }
    },

    /** 通知点击事件 */
    onClick(id) {
      const routeData = this.$router.resolve({ path: "/newsDetail", query: { id: id } });
      window.open(routeData.href, '_blank');
    },

    /** 获取轮播图 */
    lbimages() {
      lbimages().then(res => {
        if (res && res.code === 200) {
          this.imagelist = res.data?.items || [];
        }
      }).catch(error => {
        console.error('获取轮播图失败:', error);
      });
    },

    /** 内容区域加载数据 */
    contentLeft(tab) {
      if (!tab || !tab.name) return;

      if (tab.name === 'tzgg') {
        this.notice();
      } else if (tab.name === 'zbgg') {
        this.getGgList('zbgg');
      } else if (tab.name === 'zmgg') {
        this.getZmggList('zmgg');
      }
    },

    /** 获取招募公告 */
    getZmggList(val) {
      const data = { ggAnnouncement: val };
      getZmggListTwoMonth(data).then(res => {
        if (res && res.code === 200) {
          this.zmggList = res.data?.items?.slice(0, 10) || [];
        }
      }).catch(error => {
        console.error('获取招募公告失败:', error);
      });
    },

    /** 获取通知公告 */
    notice() {
      noticeApi({ page: 1, pageSize: 10 }).then(res => {
        if (res && res.code === 200) {
          this.tzggList = res.data?.items?.slice(0, 10) || [];
        }
      }).catch(error => {
        console.error('获取通知公告失败:', error);
      });
    },

    /** 跳转到新闻详情 */
    goNewsDetail(id) {
      if (!id) return;

      const currentNotice = this.tzggList.find(item => item.id === id);

      if (currentNotice && currentNotice.name === '石家庄国控城市发展投资集团有限责任公司物资集中采购管理办法（暂行）、电子采购交易平台管理办法（暂行）') {
        window.open('https://www.xcsw.net/m/test/public/%E7%89%A9%E8%B5%84%E9%9B%86%E4%B8%AD%E9%87%87%E8%B4%AD%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95%EF%BC%88%E6%9A%82%E8%A1%8C%EF%BC%89%E3%80%81%E7%94%B5%E5%AD%90%E9%87%87%E8%B4%AD%E4%BA%A4%E6%98%93%E5%B9%B3%E5%8F%B0%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95%EF%BC%88%E6%9A%82%E8%A1%8C%EF%BC%89/%E7%9F%B3%E5%AE%B6%E5%BA%84%E5%9B%BD%E6%8E%A7%E5%9F%8E%E5%B8%82%E5%8F%91%E5%B1%95%E6%8A%95%E8%B5%84%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E8%B4%A3%E4%BB%BB%E5%85%AC%E5%8F%B8%E7%89%A9%E8%B5%84%E9%9B%86%E4%B8%AD%E9%87%87%E8%B4%AD%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95%EF%BC%88%E6%9A%82%E8%A1%8C%EF%BC%89%E3%80%81%E7%94%B5%E5%AD%90%E9%87%87%E8%B4%AD%E4%BA%A4%E6%98%93%E5%B9%B3%E5%8F%B0%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95%EF%BC%88%E6%9A%82%E8%A1%8C%EF%BC%89.pdf');
        return;
      }

      if (currentNotice && currentNotice.name === '招采平台投标报价计算规则说明') {
        window.open('https://www.xcsw.net/m/test/public/notice/%E6%8B%9B%E9%87%87%E5%B9%B3%E5%8F%B0%E6%8A%95%E6%A0%87%E6%8A%A5%E4%BB%B7%E8%AE%A1%E7%AE%97%E8%A7%84%E5%88%99%E8%AF%B4%E6%98%8E.pdf');
        return;
      }

      if (currentNotice && currentNotice.name === '关于开展招采平台供应商常态化培训的公告') {
        window.open('https://www.xcsw.net/m/test/public/%E5%85%B3%E4%BA%8E%E5%BC%80%E5%B1%95%E6%8B%9B%E9%87%87%E5%B9%B3%E5%8F%B0%E4%BE%9B%E5%BA%94%E5%95%86%E5%B8%B8%E6%80%81%E5%8C%96%E5%9F%B9%E8%AE%AD%E7%9A%84%E5%85%AC%E5%91%8A/%E5%85%B3%E4%BA%8E%E5%BC%80%E5%B1%95%E6%8B%9B%E9%87%87%E5%B9%B3%E5%8F%B0%E4%BE%9B%E5%BA%94%E5%95%86%E5%B8%B8%E6%80%81%E5%8C%96%E5%9F%B9%E8%AE%AD%E7%9A%84%E5%85%AC%E5%91%8A.docx');
        return;
      }

      if (currentNotice && currentNotice.name === '入库联系方式') {
        this.$router.push({ path: "/ourself" });
        return;
      }

      const routeData = this.$router.resolve({ path: "/newsDetail", query: { id: id } });
      window.open(routeData.href, '_blank');
    },

    /** 获取公告列表 */
    getGgList(val) {
      const data = { ggAnnouncement: val };
      getGgListHome(data).then(res => {
        if (res && res.code === 200) {
          this.zbggList = res.data?.items?.slice(0, 10) || [];
        }
      }).catch(error => {
        console.error('获取公告列表失败:', error);
      });
    },

    /** 跳转到公告详情 */
    goToPage(id) {
      if (!id) return;

      const routeData = this.$router.resolve({ path: "/ggDetail", query: { id: id } });
      window.open(routeData.href, '_blank');
    },

    /** 查看更多内容 */
    contentMore() {
      if (!Cookies.get('Admin-Token')) {
        this.$message('登录之后查看更多');
        return;
      }

      if (this.content1Name === 'tzgg') {
        this.$router.push({ path: '/notice' });
      } else if (this.content1Name === 'zbgg' || this.content1Name === 'zmgg') {
        localStorage.setItem('aboutType', this.content1Name);
        this.$router.push({ path: '/about' });
      }
    },

    /** 选择登录方式 */
    selectLogo(val) {
      this.toPage('/login', val);
    },

    /** 页面跳转 */
    toPage(path, val) {
      if (path === '/guarantee') {
        window.open('http://www.gzzczb.com/guarantee/');
        return;
      }
      this.$router.push({ path: path, query: { type: val } });
      this.closeLoginDialog();
    },

    /** 业务模块点击事件 */
    businessMore(val) {
      if (!val || !val.id) return;

      switch (val.id) {
        case '3':
          window.location.href = `${process.env.VUE_APP_LOGINURL}#/login2`;
          break;
        case '2':
          if (Cookies.get('Admin-Token')) {
            window.open(`https://www.xcsw.net/ui/#/auxiliaryMeans/listPrice`);
          } else {
            this.logoDialog = true;
          }
          break;
        case '5':
          if (Cookies.get('Admin-Token')) {
            location.href = `${process.env.VUE_APP_CONTRACT_LOGINURL}`;
          } else {
            this.logoDialog = true;
          }
          break;
        case '6':
          if (Cookies.get('Admin-Token')) {
            window.open(`https://www.xcsw.net/contract/#/fileSign/file`);
          } else {
            this.logoDialog = true;
          }
          // this.$message.info("敬请期待。。。");
          break;
        case '4':
          window.open(`https://xcsw-pc.xcsw.net:7443/`);
          break;
        case '1':
          if (Cookies.get('Admin-Token')) {
            location.href = `${process.env.VUE_APP_OLDHOME}`;
          } else {
            this.logoDialog = true;
          }
          break;
        default:
          break;
      }
    },

    /** 网格图片点击事件 */
    content2More(item) {
      if (!item || !item.id) return;
      if (item.id === '3') {
        this.$router.push({ path: '/help' });
      } else if (item.id === '7') {
        window.location.href = `${process.env.VUE_APP_LOGINURL}#/login2`;
      } else if (item.id === '8') {
        this.$router.push({ path: '/zjRegister' });
      } else if (item.id === '9') {
        if (Cookies.get('Admin-Token')) {
          location.href = `${process.env.VUE_APP_CONTRACT_LOGINURL}`;
        } else {
          this.logoDialog = true;
        }
      } else if (item.id === '5') {
        window.open(`https://xcsw-pc.xcsw.net:7443/`);
      } else if (item.id === '4') {
        window.location.href = `${process.env.VUE_APP_LOGINURL}#/login2`;
      } else if (item.id === '6') {
        if (Cookies.get('Admin-Token')) {
          window.open(`https://www.xcsw.net/contract/#/fileSign/file`);
        } else {
          this.logoDialog = true;
        }
      } else if (item.id === '2') {
        if (Cookies.get('Admin-Token')) {
          window.open(`https://www.xcsw.net/ui/#/auxiliaryMeans/listPrice`);
        } else {
          this.logoDialog = true;
        }
      } else {
        if (Cookies.get('Admin-Token')) {
          if (item.id === '1') {
            location.href = `${process.env.VUE_APP_OLDHOME}`;
          } else if (item.id === '5') {
            getLoginStatus().then(res => {
              const data = res?.data || {};
              if (data.identity === "gys") {
                // 供应商
                if (data.state) {
                  window.open(`/redirect?r=https://xcsw-multishop.sjzszjjt.com:7443/`);
                } else {
                  this.$message.warning('未通过主体认证或入库审核还未通过');
                }
              } else if (data.identity === "ptf") {
                // 平台方
                window.open(`/redirect?r=https://xcsw-platform.sjzszjjt.com:7443/`);
              } else if (data.identity === "cgr") {
                // 采购人
                if (data.state) {
                  window.open(`/redirect?r=https://xcsw-pc.sjzszjjt.com:7443/`);
                } else {
                  this.$message.warning('未通过主体认证或平台审核还未通过');
                }
              }
            }).catch(error => {
              console.error('获取登录状态失败:', error);
              this.$message.error('获取登录状态失败，请重试');
            });
          } else if (item.id === '10') {
            console.log(process.env.VUE_APP_CONTRACT_LOGINURL)
            // `${process.env.VUE_APP_LOGINURL}`;
            location.href = `${process.env.VUE_APP_CONTRACT_LOGINURL}`
          }
        } else {
          this.logoDialog = true;
        }
      }
    },

    /** 格式化日期 */
    formatDate(dateString) {
      if (!dateString) return '';
      // 确保日期格式正确
      return dateString.substring(0, 10);
    },

    /** 友情链接点击事件 */
    friendlyLinks(val) {
      if (val && val.url) {
        window.open(val.url, '_blank');
      }
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

/* 飘窗样式 */
.float-notice {
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: fixed;
  z-index: 1000;
  overflow: hidden;
  transition: all 0.3s ease;
}

.float-header {
  background: #13319f;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.close-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
}

.float-body {
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  height: calc(100% - 48px);
  overflow-y: auto;
}

.rotationChart {
  background-color: #F1F3F5;
}

.content_top_content_right {
  width: 328px;
  background: #FFFFFF;
  border-radius: 4px;
  margin-left: 16px;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
}

.top-image {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 328px;
  height: 80px;
}

.grid-images {
  position: absolute;
  top: 122px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.grid-item {
  width: 138px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-wrapper {
  width: 138px;
  height: 88px;
  overflow: hidden;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.text-below {
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  color: #333;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0px;

  &:hover {
    color: #409EFF;
  }
}

.tab-button-group {
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  padding: 0;
  overflow: hidden;
  text-align: center;
  display: flex;
  align-items: center;
  font-size: 20px;
}

.tab-button {
  flex: 1;
  min-width: 0;
  padding: 12px 0;
  text-align: center;
  background-color: #ffffff;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 32px;

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:nth-child(2) {
    border-radius: 0;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &:hover {
    background-color: #409EFF;
    color: white;
  }

  &.active {
    background-color: #409EFF;
    color: white;
    font-weight: bold;
  }
}

.white-bg {
  background-color: #fff;
  padding: 15px;
  border-radius: 0 4px 4px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-top: 0px;
  min-height: 499px;
}

// 登录遮罩层样式
.login-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1999;
  transition: opacity 0.3s ease;
}

// 登录弹窗样式
.login-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 720px;
  max-width: 90%;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  transition: all 0.3s ease;

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 84px;
    padding: 0 30px;
    background: url(@/assets/longing_title.png) 100%/cover no-repeat;

    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 22px;
      font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    }

    .close-icon {
      cursor: pointer;

      img {
        width: 19px;
        height: 19px;
      }
    }
  }

  .login-options {
    padding: 24px 0;

    .login-option {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      width: 400px;
      max-width: 80%;
      margin: 24px auto;
      border: 1px solid rgba(220, 220, 220, 1);
      border-radius: 4px;
      background-color: white;
      cursor: pointer;
      transition: all 0.3s ease;

      span {
        color: rgba(51, 51, 51, 1);
        font-size: 20px;
        font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
      }

      &:hover {
        background-color: #409EFF;
        border-color: #409EFF;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);

        span {
          color: white;
        }
      }
    }
  }
}

// 防止遮罩层和弹窗出现滚动条
body.modal-open {
  overflow: hidden;
}

.content_top {
  background-color: #F1F3F5;
  padding: 11px;
}

.content_top_content {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.content_top_content_left {
  width: 1016px;
}

.content_top_content_left_content {
  border-right: 1px solid #C7C7C7;
  height: 220px;
  overflow: auto;
  padding: 0 10px;
  padding-left: 80px;
}

.content_top_content_right {
  width: 328px;
  height: 585px;
  background: #FFFFFF;
  border-radius: 4px;
  margin-left: 16px;
}

.content_top_content_right_content {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  padding-left: 25px;
}

.content_top_content_right_content-DIV {
  margin-right: 50px !important;
}

.content_top_content_right_content div {
  padding: 20px 30px;
  margin: 10px;
  background-color: #13319f;
  color: #ffffff;
  border-radius: 4px;
}

.content {
  background-color: #F1F3F5;
}

.content_BusinessModule_content {
  background-color: #f8f8f8;
  margin-top: 20px;
  padding: 0 0 20px 0;
  margin-bottom: 40px;

}

.business-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  width: 100%;
}

.business-image {
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
}

.bottom {
  background-color: #f8f8f8;
  padding: 20px;
  margin-top: 20px;
}

.bottom-content {
  margin: 0 auto;
  width: 800px;
  cursor: pointer;
}

.bottom-content div {
  margin: 5px;
  font-size: 14px;

}

.toolitem {
  transition: all 0.5s;
  padding: 0px;
  cursor: pointer;
  color: #333333;
  position: relative;
}

.toolitem.action,
.toolitem:hover {
  color: #0a84ff;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item,
::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav,
::v-deep .el-tabs--card>.el-tabs__header {
  border: none;
  font-size: 19px;
}
</style>
